// extracted by mini-css-extract-plugin
module.exports = {"occupations":"occupations-module--occupations--2Rqv5"};